const config = {
    // SERVER_URL: "http://localhost:8085/dab",
    SERVER_URL: "https://admin.dabs.af",
  };
  
  export default config;